import { AboutButtons } from "./types";

export const deTranslations: AboutButtons = {
        readMore: "Mehr lesen",
        website: "clinicalmetrics.co.uk"
};